/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Actions_Display_NameInputs */

const es_admin_users_actions_display_name = /** @type {(inputs: Admin_Users_Actions_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de Usuario`)
};

const en_admin_users_actions_display_name = /** @type {(inputs: Admin_Users_Actions_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {Admin_Users_Actions_Display_NameInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_actions_display_name = /** @type {((inputs?: Admin_Users_Actions_Display_NameInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Actions_Display_NameInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_actions_display_name(inputs)
	return en_admin_users_actions_display_name(inputs)
});
export { admin_users_actions_display_name as "admin.users.actions.display_name" }